import { Image } from '@chakra-ui/react';
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import mff2Sim from 'assets/images/embeddedSim.png';
import esimSim from 'assets/images/esimQR.png';
import singleSim from 'assets/images/singleSimCard.png';
import { type SimCardImageVariant } from 'utils/hooks';

interface SimCardImageProps {
  variant: SimCardImageVariant;
}

const SIM_CARD_IMAGES: Record<SimCardImageVariant, { src: string; w: string[]; altKey: string }> = {
  classic: {
    src: singleSim,
    w: ['70%', '50%'],
    altKey: 'scannedSim.classicSimCard',
  },
  mff2: {
    src: mff2Sim,
    w: ['60%', '40%'],
    altKey: 'scannedSim.embeddedSimCard',
  },
  esim: {
    src: esimSim,
    w: ['40%', '28%'],
    altKey: 'scannedSim.esimCard',
  },
};

export const SimCardImage: FunctionComponent<SimCardImageProps> = ({ variant }) => {
  const { t } = useTranslation();
  const { src, w, altKey } = SIM_CARD_IMAGES[variant];

  return <Image src={src} w={w} alt={t(altKey)} />;
};
